package ui.app.assign.detail.kindergarten.editor.page

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.lazy.staggeredgrid.LazyVerticalStaggeredGrid
import androidx.compose.foundation.lazy.staggeredgrid.StaggeredGridCells
import androidx.compose.foundation.lazy.staggeredgrid.items
import androidx.compose.material3.Card
import androidx.compose.material3.FloatingActionButton
import androidx.compose.material3.Icon
import androidx.compose.material3.SmallFloatingActionButton
import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.layout.ContentScale
import androidx.compose.ui.unit.dp
import api.ResourceOrientation
import api.ResourceType
import apps.App
import apps.colors
import com.mohamedrejeb.richeditor.ui.material3.RichText
import compose.assets.Svg
import compose.assets.svg.DeleteEmpty
import compose.assets.svg.Plus
import org.ssoft.common.type.AspectRatio
import ssoft.frontend.generated.resources.Res
import ssoft.frontend.generated.resources.global_empty
import ssoft.frontend.generated.resources.layer_bottom__kindergarten_picture_small_tooltip
import tools.GlobalObjectShare
import tools.rememberRichTextState
import ui.app.assign.detail.kindergarten.editor.AppKindergartenEditorScope
import ui.app.assign.detail.kindergarten.editor.NextAndSkip
import ui.resource.ResourceListingArgs
import ui.widget.ColorField
import ui.widget.LazyImage

@Composable
fun AppKindergartenEditorScope.KindergartenPage04Icons(nnvl: AppKindergartenEditorScope.Wrapper) {

    val imagePickerKey = "KindergartenPage04Icons"

    GlobalObjectShare.Consumer(imagePickerKey)

    val adapter = remember {
        nnvl.adapterCustomPhotoSmall
    }

    fun openResourcePicker() {
        GlobalObjectShare.launchImagePicker(
            key = imagePickerKey,
            nav = nav,
            args = ResourceListingArgs(
                companyId = args.companyId,
                restrictionOrientation = ResourceOrientation.HORIZONTAL.mask,
                restrictionType = ResourceType.IMAGE.mask,
                restrictionCanIgnoreAspectRatio = false,
                restrictionAspectRatio = AspectRatio._1_1.mask,
                excluded = adapter.state.joinToString(",") { it.resource.state.toString() }
            )
        ) {
            it.firstOrNull()?.also {
                adapter.add(
                    index = 0,
                    newItem = App.Kindergarten.Photo(
                        resource = it.id,
                        names = mutableListOf(it.name),
                        colorBg = (App.Kindergarten.colors.random() + 0xFF000000)
                    )
                )
            }
        }
    }

    Box(Modifier.fillMaxSize()) {

        if (adapter.state.isEmpty()) {
            RichText(
                state = rememberRichTextState(Res.string.layer_bottom__kindergarten_picture_small_tooltip),
                modifier = Modifier.align(Alignment.TopCenter)
                    .padding(16.dp)
            )
        } else {
            LazyVerticalStaggeredGrid(
                columns = StaggeredGridCells.FixedSize(256.dp),
                modifier = Modifier.fillMaxSize(),
                verticalItemSpacing = 16.dp,
                horizontalArrangement = Arrangement.spacedBy(16.dp),
                contentPadding = PaddingValues(
                    start = 16.dp,
                    end = 16.dp,
                    top = 16.dp,
                    bottom = 32.dp
                )
            ) {
                items(adapter.state) {
                    IconItem(it) {
                        adapter.removeAll { entry -> entry.resource.state == it.resource.state }
                    }
                }
            }
        }

        NextAndSkip(Modifier.align(Alignment.BottomCenter).padding(16.dp))

        FloatingActionButton(
            onClick = { openResourcePicker() },
            modifier = Modifier.align(Alignment.BottomEnd).padding(16.dp)
        ) {
            Icon(Svg.Plus, null)
        }
    }
}

@Composable
private fun AppKindergartenEditorScope.IconItem(
    item: AppKindergartenEditorScope.WrapperPhotoEntry.Item,
    onDelete: () -> Unit
) {
    Card {
        Box {
            Column {
                LazyImage(
                    id = item.resource.state,
                    alphaBackground = false,
                    contentScale = ContentScale.Crop,
                    modifier = Modifier.fillMaxWidth()
                        .background(item.colors.state)
                        .aspectRatio(1F)
                )
                ColorField(
                    field = item.colors,
                    label = Res.string.global_empty,
                    modifier = Modifier.fillMaxWidth()
                )

            }
            SmallFloatingActionButton(
                onClick = onDelete,
                modifier = Modifier.align(Alignment.TopEnd)
                    .padding(8.dp)
            ) {
                Icon(Svg.DeleteEmpty, null)
            }
        }
    }
}